import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env, hasBackend } from './env';

/** The Supabase client, or null in demo mode (no backend configured). */
export const supabase: SupabaseClient | null = hasBackend
  ? createClient(env.supabaseUrl, env.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
        storageKey: 'karya-auth',
      },
      realtime: { params: { eventsPerSecond: 10 } },
    })
  : null;

// Development only: lets local end-to-end scripts sign in a test user.
if ((import.meta.env.DEV || import.meta.env.VITE_E2E === 'true') && supabase)
  (window as unknown as { __karyaSupabase?: SupabaseClient }).__karyaSupabase = supabase;

export function requireSupabase(): SupabaseClient {
  if (!supabase) throw new Error('Supabase is not configured');
  return supabase;
}

/** URL of an Edge Function. */
export function functionUrl(name: string): string {
  return `${env.supabaseUrl}/functions/v1/${name}`;
}
